import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetAdminBookingsParams,
  ApiGetBookingsParams,
  BackendErrorEntity,
  GetCalcomBookingsAdminResponseDto,
  GetCalcomBookingsCustomerResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetBookings = (
    params?: MaybeRef<ApiGetBookingsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetCalcomBookingsCustomerResponseDto>(
      {url: `/calcom/bookings`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetBookingsQueryKey = (params?: MaybeRef<ApiGetBookingsParams>,) => {
    return ['calcom','bookings', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetBookingsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetBookings>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetBookingsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetBookings>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetBookingsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetBookings>>> = () => apiGetBookings(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetBookings>>, TError, TData> 
}

export type ApiGetBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetBookings>>>
export type ApiGetBookingsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetBookings<TData = Awaited<ReturnType<typeof apiGetBookings>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetBookingsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetBookings>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetBookingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetAdminBookings = (
    params?: MaybeRef<ApiGetAdminBookingsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetCalcomBookingsAdminResponseDto>(
      {url: `/calcom/admin/bookings`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetAdminBookingsQueryKey = (params?: MaybeRef<ApiGetAdminBookingsParams>,) => {
    return ['calcom','admin','bookings', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetAdminBookingsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetAdminBookings>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetAdminBookingsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetAdminBookings>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetAdminBookingsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetAdminBookings>>> = () => apiGetAdminBookings(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetAdminBookings>>, TError, TData> 
}

export type ApiGetAdminBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetAdminBookings>>>
export type ApiGetAdminBookingsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetAdminBookings<TData = Awaited<ReturnType<typeof apiGetAdminBookings>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetAdminBookingsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetAdminBookings>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetAdminBookingsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiCalcomWebhook = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<void>(
      {url: `/calcom/webhook`, method: 'POST'
    },
      options);
    }
  


export const getApiCalcomWebhookMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCalcomWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCalcomWebhook>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCalcomWebhook>>, void> = () => {
          

          return  apiCalcomWebhook(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCalcomWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof apiCalcomWebhook>>>
    
    export type ApiCalcomWebhookMutationError = ErrorType<BackendErrorEntity>

    export const useApiCalcomWebhook = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCalcomWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCalcomWebhook>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getApiCalcomWebhookMutationOptions(options);

      return useMutation(mutationOptions);
    }
    